import {PTGC_AVAILABLE_ACTIONS} from './../../constants';

const setAvailableCalendars = availableCalendars => ({
    type: PTGC_AVAILABLE_ACTIONS,
    availableCalendars
});

export default setAvailableCalendars;